import CreateVendorProductContainer from "./CreateVendorProductContainer";
export default CreateVendorProductContainer;
